import React, { useState, useEffect, useRef, useMemo } from 'react';
import CampaignDetails from '../CampaignDetails';
import GraphSection from '../GraphSection';
import { DashboardWrap } from '../CampaignDetails/CampaignDetails.styles';
import campaignService from '../../../services/campaignService';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import { useLocation } from 'react-router-dom';

const CampaignAnalytics = ({ isEdit }) => {
  const { fetch } = useContextHook(AuthContext, v => ({
    fetch: v.fetch,
  }));
  const location = useLocation();
  const campaignId = location.state?.campaign_id;

  // Fetch graph data once and share with both components
  const { campaign_graph_data, campaign_graph_loading } = campaignService.GetCampaignGraphAnalytics(
    isEdit ? campaignId : null,
    fetch,
  );


  const graphDataMap = useMemo(() => {
    if (!campaign_graph_data?.data?.results) return null;

    const results = campaign_graph_data?.data?.results;
    const toNumber = val => {
      const num = Number(val);
      return isNaN(num) ? 0 : num;
    };

    return {
      emailsSent: results.map(item => toNumber(item.emailssent)),
      emailsOpened: results.map(item => toNumber(item.emailsopened)),
      replies: results.map(item => toNumber(item.replies)),
      clicks: results.map(item => toNumber(item.clicks)),
      positivereply: results.map(item => toNumber(item.positivereply)),
      opportunity: results.map(item => toNumber(item.opportunity)),
      unsubscribed: results.map(item => toNumber(item.unsubscribed)),
      bounced: results.map(item => toNumber(item.bounced)),
    };
  }, [campaign_graph_data]);


  return (
    <>
      <DashboardWrap className="step-mode">
        <CampaignDetails isEdit={isEdit} graphDataFromParent={graphDataMap} />
        <GraphSection isEdit={isEdit} campaign_graph_data={campaign_graph_data} />
      </DashboardWrap>
    </>
  );
};

export default CampaignAnalytics;
